import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { subscribeTo } from '@/core/rxjs-helpers';

export function useWindowResize(onResize: () => void) {
    const resize = fromEvent(window, 'resize').pipe(debounceTime(500));
    subscribeTo(resize, onResize);
}
